<mat-form-field appearance="outline">
  <mat-label>{{ label ?? name }}</mat-label>
  <mat-select
    #employerObjectSelect
    [formControl]="inputControl"
    [placeholder]="placeholder"
    [multiple]="true"
    #multiSelect
    [compareWith]="compareFunc"
    >
    <mat-select-trigger>
      <div class="input-text-wrapper">
        @if (inputControl.value?.length) {
          <span class="text">{{ inputControl.value[0].Name }}</span>
        }
        @if (inputControl.value?.length > 1) {
          <div class="more-label">+{{ inputControl.value?.length - 1 }}</div>
        }
      </div>
    </mat-select-trigger>
    <mat-option>
      <ngx-mat-select-search
        [placeholderLabel]="'Search' | translate"
        [noEntriesFoundLabel]="'SearchingNoResult' | translate"
        [formControl]="itemsFiltering"
        [searching]="searching"
        [showToggleAllCheckbox]="true"
        [clearSearchInput]="false"
        [toggleAllCheckboxChecked]="isAllSelected$ | async"
        (toggleAll)="toggleSelectAll($event)"
      ></ngx-mat-select-search>
    </mat-option>
    @if (filteredServerSideItems$ | async) {
      @for (item of notVisibleSelectedItems$ | async; track item) {
        <mat-option [value]="item" [hidden]="true"> {{ item.Name }} </mat-option>
      }
    }

    @for (employerObject of (filteredServerSideItems$ | async) ?? inputControl.value; track employerObject) {
      <mat-option [value]="employerObject">
        <div class="option-content">
          <span class="option-name">{{ employerObject.Name }}</span>
          @if (employerObject.Description) {
            <span class="option-annotation">{{ employerObject.Description }}</span>
          }
        </div>
      </mat-option>
    }

    @if (filteredServerSideItems$ | async; as filteredServerSideItems) {
      @if (filteredServerSideItems.length !== (count$ | async)) {
        <div class="mat-select-button" (click)="loadMore()">
          <button mat-button>Pokaż więcej</button>
        </div>
      }
      @if (filteredServerSideItems.length) {
        <div class="mat-select-footer">
          <span class="item-counter">{{ filteredServerSideItems.length }} z {{ count$ | async }}</span>
        </div>
      }
    }
  </mat-select>
  @if (description) {
    <mat-hint>
      <mat-icon>info</mat-icon>
      {{ description }}
    </mat-hint>
  }
</mat-form-field>
